const targetNode = document.body;
const config = { childList: true, subtree: true };

const callback: MutationCallback = (mutationList) => {
  const overlay = document.querySelector('jb-modal');
  if (overlay) {
    mutationList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const addedNodes = Array.from(mutation.addedNodes) || [];
        const popupNodes = addedNodes.filter((node): node is HTMLElement => node instanceof HTMLElement && node.tagName === 'JB-POPUP');
        if (popupNodes.length > 0) {
          const dialog = overlay.shadowRoot?.querySelector('dialog');
          const popup = popupNodes[0];
          dialog?.insertAdjacentElement('beforeend', popup);
        }
      }
    });
  }
};
const observer = new MutationObserver(callback);
observer.observe(targetNode, config);
